// extracted by mini-css-extract-plugin
export default {"layout":"ktK7kYqKG9O1iPrN0TWB0A==","de-layout":"Bi5mYleq4hutT2WPIQP9RA==","paymentLink":"WCRbGMvxyHW8rdphQxmDwQ==","divider":"Sa0n5M1O8-bUgU-DsV7eDg=="};